import { render } from "./DistinctMmsiBar.vue?vue&type=template&id=2afe45b8&scoped=true"
import script from "./DistinctMmsiBar.vue?vue&type=script&lang=js"
export * from "./DistinctMmsiBar.vue?vue&type=script&lang=js"

import "./DistinctMmsiBar.vue?vue&type=style&index=0&id=2afe45b8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afe45b8"]])

export default __exports__